// layouts/MainLayout.js
import React, { useState, useEffect, createContext } from 'react';
import Header from './Header';
import SideBar from './SideBar';
import { Outlet } from 'react-router-dom';

// Sidebar context to share expand/collapse state
export const SidebarContext = createContext({
  isExpanded: false,
  setIsExpanded: () => {},
});

const MainLayout = () => {
  const [isExpanded, setIsExpanded] = useState(false);

  // Handle window resize – auto-collapse sidebar on smaller screens
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 768) {
        setIsExpanded(false);
      }
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const userRole = (localStorage.getItem('role') || '').toLowerCase();
  const isCustomerUser = userRole === 'customer';

  return (
    <SidebarContext.Provider value={{ isExpanded, setIsExpanded }}>
      <div className="flex flex-col min-h-screen bg-gray-100">
        {/* Fixed Header */}
        <Header />

        <div className="flex flex-1">
          {/* Sidebar (Hidden for Customer Users) */}
          {!isCustomerUser && <SideBar />}

          {/* Main Content */}
          <main
            className="flex-1 transition-all duration-300 mt-[65px] p-4"
            style={{
              paddingLeft: isCustomerUser ? '1rem' : (isExpanded ? '16rem' : '4rem'),
            }}
          >
            <div className="max-w-[100%] mx-auto">
              <Outlet />
            </div>
          </main>
        </div>
      </div>
    </SidebarContext.Provider>
  );
};

export default MainLayout;
